import React, { useState, useEffect } from 'react';
import certificateImage from '../assets/SECETARY222.png';

const CertificateDisplay = () => {
  // Certificate dimensions
  const originalWidth = 2246;
  const originalHeight = 2964;
  const aspectRatio = originalWidth / originalHeight;

  // State to track window width
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  // Update window width on resize
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Apply py-4 if screen is less than 465px, else use the default padding
  const paddingClass = windowWidth < 465 ? 'py-2' : 'py-24 sm:py-32 md:py-32 lg:py-36';

  return (
    <div className={paddingClass}>
      <div className="flex justify-center items-center min-h-screen p-4">
        <div className="w-full max-w-2xl md:max-w-md lg:max-w-lg">
          {/* Certificate container with responsive sizing */}
          <div
            className="relative overflow-hidden shadow-lg rounded-md"
            style={{
              paddingBottom: `${(1 / aspectRatio) * 100}%`, // Maintain aspect ratio
            }}
          >
            <img
              src={certificateImage}
              alt="Certificate"
              className="absolute top-0 left-0 w-full h-full object-contain"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CertificateDisplay;